module.exports = __webpack_public_path__ + "static/media/pag-LandingPage-Box-MuitoBoaMedalha-h.2236114a.2236114a.png";